import { render } from "./AppLazy.vue?vue&type=template&id=96fd5e90"
import script from "./AppLazy.vue?vue&type=script&lang=js"
export * from "./AppLazy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__